module.exports = __webpack_public_path__ + "media/images/completed-ae9e3146.jpg";